<template>
  <div align="center" style="margin-top: 10px;width: 1440px; margin: 0px auto; height: 100%;" >
    <div style="width:600px;" align="center">
      <img src="../../assets/20140211-20141111.png" width="100%">
    </div>
    <div style="width:600px;" align="center">
      <img src="../../assets/20141127-20150322.png"  width="100%">
    </div>
    <div style="width:600px;" align="center">
     <img src="../../assets/20150419-20150801.png"  width="100%">
    </div>
    <div style="width:600px;" align="center">
      <img src="../../assets/20150901-20160122.png"  width="100%">
    </div>
    <div style="width:600px;" align="center">
      <img src="../../assets/beamClean_total.png"  width="100%">
    </div>
    <div align="center">
      <a href="../../../static/beamcleaningdata/beamCleanTotalData.txt" style="font-size: large">RAW DATA</a>
    </div>
  </div>
</template>

<script>
    export default {
        name: "beamcleaning"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/activePublic/beamcleaning.vue